export default "__VITE_ASSET__DfSgBU0i__"